import { AuthService } from 'src/app/bo/services/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

// services
import { OrdersService } from '../services/orders.service';

// interface
import { OrderDetails } from '../interfaces/order-details'

@Component({
    selector: 'app-order-management',
    templateUrl: './order-management.component.html',
    styleUrls: ['./order-management.component.scss']
})
export class OrderManagementComponent implements OnInit {

    @Input() public order;
    @Input() public network;
    @BlockUI() blockUI: NgBlockUI;
    @Output() updateData: EventEmitter<{ status: string, message: string }> = new EventEmitter();

    role: string;

    orderDetails: OrderDetails;
    orderReady: boolean = false;
    displayTextarea: boolean = false;
    displayFooterBtn: boolean = false;
    currentAction: string = '';
    textarea: string = '';
    PAYMENT_NOT_RECEIVED: string = 'PAYMENT_NOT_RECEIVED';
    USER_REFUSAL: string;

    // disabled / enable btn
    btn_order_refused: boolean;
    btn_payment_received: boolean;
    btn_order_sent: boolean;
    btn_order_delivered: boolean;
    btn_cancel_order: boolean;
    btn_blocage_metrage: boolean;
    btn_blocage_usine: boolean;
    // btn_payment_refused: boolean;

    // selected btn
    selectedOrderRefused: boolean;
    selectedPaymentReceived: boolean;
    selectedOrderDelivered: boolean;
    selectedOrderSent: boolean;
    selectedCancelOrder: boolean;
    selectedBlocageMetrage: boolean;
    selectedBlocageUsine: boolean;
    // selectedPaymentRefused: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private ordersService: OrdersService,
        private toastrService: ToastrService,
        private authService: AuthService
    ) { }

    ngOnInit(): void {
        this.getOrder();
    }

    // CRUD order
    public sendAction(currentAction: string, formValue: { textarea: string }): void {
        this.blockUI.start('Loading');

        if (currentAction === 'order_refused' || currentAction === 'order_cancelled') {

            if (formValue.textarea === '') {
                this.blockUI.stop();
                this.toastrService.error('Merci de justifier le problème');
                return
            }
            this.cancelOrder(formValue.textarea, currentAction);

        } else if (currentAction === 'payment_received') {
            this.paymentOrderAccepted();
            // } else if (currentAction === 'payment_refused') {
            // 	this.paymentOrderRefused();
        } else if (currentAction === 'order_delivered') {
            this.orderCompleted();
        } else if (currentAction == 'order_sent') {
            this.orderSentToCustomer();
        } else if (currentAction == 'blocage_metrage') {
            if (formValue.textarea === '') {
                this.blockUI.stop();
                this.toastrService.error('Merci de justifier le problème');
                return
            }
            this.blocageMetrageOrder(formValue.textarea);
        } else if (currentAction == 'blocage_usine') {
            if (formValue.textarea === '') {
                this.blockUI.stop();
                this.toastrService.error('Merci de justifier le problème');
                return
            }
            this.blocageUsineOrder(formValue.textarea);
        }
        this.blockUI.stop();
        this.activeModal.close();
    }

    public cancelChange() {
        this.activeModal.close();
        this.toastrService.warning('Modification annulée');
    }

    public orderRefused(): void {
        this.resetSelectedBtn();
        this.showTextarea();
        this.currentAction = 'order_refused';
        this.selectedOrderRefused = true;
    }

    public orderBlocageMetrage(): void {
        this.resetSelectedBtn();
        this.showTextarea();
        this.currentAction = 'blocage_metrage';
        this.selectedBlocageMetrage = true;
    }

    public orderBlocageUsine(): void {
        this.resetSelectedBtn();
        this.showTextarea();
        this.currentAction = 'blocage_usine';
        this.selectedBlocageUsine = true;
    }

    public orderSent(): void {
        this.resetSelectedBtn();
        this.hideTextarea();
        this.currentAction = 'order_sent';
        this.selectedOrderSent = true;
    }

    public paymentReceived(): void {
        this.resetSelectedBtn();
        this.hideTextarea();
        this.currentAction = 'payment_received';
        this.selectedPaymentReceived = true;
        this.selectedOrderSent = false;
    }

    // public paymentRefused(): void{
    // 	this.resetSelectedBtn();
    // 	this.hideTextarea();
    // 	this.currentAction = 'payment_refused';
    // 	this.selectedPaymentRefused = true;
    // }

    public orderDelivered(): void {
        this.resetSelectedBtn();
        this.hideTextarea();
        this.currentAction = 'order_delivered';
        this.selectedOrderDelivered = true;
    }

    public orderCancelled(): void {
        this.resetSelectedBtn();
        this.showTextarea();
        this.currentAction = 'order_cancelled';
        this.selectedCancelOrder = true;
    }

    private resetSelectedBtn() {
        this.selectedOrderRefused = false;
        this.selectedPaymentReceived = false;
        // this.selectedPaymentRefused = false;
        this.selectedOrderDelivered = false;
        this.selectedCancelOrder = false;
    }

    private showTextarea(): void {
        this.displayTextarea = true;
        this.displayFooterBtn = true;
    }

    private hideTextarea(): void {
        this.displayTextarea = false;
        this.displayFooterBtn = true
    }

    // activer / désactiver les btn en fonction du rôle et / ou du statut de la commande
    private setDisplayBtn(): void {
       if (this.orderDetails.status == "to-process" && this.role === 'Provider') {
            this.btn_order_refused = false;
            this.btn_payment_received = true;
            this.btn_order_delivered = true;
            this.btn_order_sent = true;
            this.btn_cancel_order = true;
            this.btn_blocage_metrage = true;
            this.btn_blocage_usine = false;
        } else if (this.orderDetails.status == "to-process" && this.role === 'Shop') {
            this.btn_order_refused = false;
            this.btn_payment_received = false;
            this.btn_order_delivered = true;
            this.btn_order_sent = true;
            this.btn_cancel_order = false;
            this.btn_blocage_metrage = false;
            this.btn_blocage_usine = false;
        }else if (this.orderDetails.status == "processing" && this.role === 'Provider') {
            this.btn_order_refused = true;
            this.btn_payment_received = true;
            this.btn_order_delivered = true;
            this.btn_order_sent = false;
            this.btn_cancel_order = true;
            this.btn_blocage_metrage = true;
            this.btn_blocage_usine = true;
        }else if (this.orderDetails.status == "processing" && this.role === 'Shop') {
            this.btn_order_refused = true;
            this.btn_payment_received = true;
            this.btn_order_delivered = false;
            this.btn_order_sent = false;
            this.btn_cancel_order = true;
            this.btn_blocage_metrage = true;
            this.btn_blocage_usine = true;
        }else if (this.orderDetails.status == "shipped" && this.role === 'Provider') {
            this.btn_order_refused = true;
            this.btn_payment_received = true;
            this.btn_order_delivered = true;
            this.btn_order_sent = true;
            this.btn_cancel_order = true;
            this.btn_blocage_metrage = true;
            this.btn_blocage_usine = true;
        }else if (this.orderDetails.status == "shipped" && this.role === 'Shop') {
            this.btn_order_refused = true;
            this.btn_payment_received = true;
            this.btn_order_delivered = false;
            this.btn_order_sent = true;
            this.btn_cancel_order = true;
            this.btn_blocage_metrage = true;
            this.btn_blocage_usine = true;
        }
    }

    // Request
    private getOrder(): void {
        this.blockUI.start('Loading');

        this.ordersService.getOrderDetails(this.order.id, this.network).subscribe(
            (res) => {
                if (res.success) {
                    this.orderDetails = res.data;

                    const token = localStorage.getItem('token');

                    this.authService.decodeJWT(token).subscribe(
                        (res) => {
                            if (res.success) {
                                this.role = res.data.role;
                                this.setDisplayBtn();
                                this.blockUI.stop();
                                this.orderReady = true
                                this.blockUI.stop();
                            } else {
                                this.blockUI.stop();
                            }
                        },
                        (error) => {
                            this.blockUI.stop();
                        }
                    );
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('ERROR_SERVER')) {
                        this.toastrService.error('Une erreur serveur est survenue');
                    } else {
                        this.toastrService.error('Une erreur s\'est produite');
                    }
                    this.activeModal.close();
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    private cancelOrder(textareaMessage: string, action: string): void {
        this.blockUI.start('Loading');

        switch (this.role) {
            case ("Provider"):
                this.USER_REFUSAL = 'PROVIDER_REFUSAL';
                break;
            case ("Shop"):
                this.USER_REFUSAL = 'SHOP_REFUSAL';
                break;
        }

        this.ordersService.cancelOrder(this.orderDetails.id, this.network, this.USER_REFUSAL, action, textareaMessage).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `Le commande n°${this.orderDetails.parentId} a bien été annulée` });
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: `La commande n°${this.orderDetails.id} n\'existe pas` });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }

    private paymentOrderAccepted(): void {
        this.blockUI.start('Loading');

        this.ordersService.paymentOrderAccepted(this.orderDetails.id, this.network).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `Le statut de paiement de la commande n°${this.orderDetails.id} a bien été modifié` });
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: 'La commande n\'existe pas' });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }

    // private paymentOrderRefused(): void {
    // 	this.blockUI.start('Loading'); 

    // 	this.ordersService.paymentOrderRefused(this.orderDetails.id, this.PAYMENT_NOT_RECEIVED).subscribe(
    // 		(res) => {
    // 			if (res.success) {
    // 				// this.orderDetails = res.data;
    // 				this.blockUI.stop();
    // 				this.updateData.emit({status: 'success', message: `Le statut de paiement de la commande n°${this.orderDetails.id} a bien été modifié`});				
    // 			} else {
    // 				this.blockUI.stop();

    // 				if (res.errorSet.includes('INVALID_PARAMS')) {
    // 					this.updateData.emit({status: 'error', message: 'Les paramètres sont invalides'});		
    // 				} else if (res.errorSet.includes('ORDER_NOTFOUND')) {
    // 					this.updateData.emit({status: 'error', message: 'La commande n\'existe pas'});					
    // 				} else if (res.errorSet.includes('UNAUTHORIZED')) {
    // 					this.updateData.emit({status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande'});				
    // 				} else if (res.errorSet.includes('INVALID_ACTION')) {
    // 					this.updateData.emit({status: 'error', message: 'La commande ne peut pas être annulée'});				
    // 				} else {
    // 					this.updateData.emit({status: 'error', message: 'Une erreur s\'est produite'});
    // 				}
    // 			}
    // 		},
    // 		(error) => {
    // 			this.blockUI.stop();
    // 			// console.error(error);
    // 			this.updateData.emit({status: 'error', message: 'Une erreur s\'est produite'});
    // 		}
    // 	);
    // }

    private orderCompleted(): void {
        this.blockUI.start('Loading');

        this.ordersService.orderCompleted(this.orderDetails.id, this.network).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `La commande n°${this.orderDetails.id} a bien été livrée` });
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: 'La commande n\'existe pas' });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }

    private blocageMetrageOrder(textareaMessage: string): void {
        this.blockUI.start('Loading');

        switch (this.role) {
            case ("Provider"):
                this.USER_REFUSAL = 'PROVIDER_REFUSAL';
                break;
            case ("Shop"):
                this.USER_REFUSAL = 'SHOP_REFUSAL';
                break;
        }

        this.ordersService.orderBlocageMetrage(this.orderDetails.id, this.network, this.USER_REFUSAL, textareaMessage).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `Le commande n°${this.orderDetails.parentId} a bien été annulée` });
                } else {
                    console.log('non')
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: `La commande n°${this.orderDetails.id} n\'existe pas` });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }
    private blocageUsineOrder(textareaMessage: string): void {
        this.blockUI.start('Loading');

        switch (this.role) {
            case ("Provider"):
                this.USER_REFUSAL = 'PROVIDER_REFUSAL';
                break;
            case ("Shop"):
                this.USER_REFUSAL = 'SHOP_REFUSAL';
                break;
        }

        this.ordersService.orderBlocageUsine(this.orderDetails.id, this.network, this.USER_REFUSAL, textareaMessage).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `Le commande n°${this.orderDetails.parentId} a bien été annulée` });
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: `La commande n°${this.orderDetails.id} n\'existe pas` });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }
    private orderSentToCustomer(): void {
        this.blockUI.start('Loading');

        this.ordersService.orderSent(this.orderDetails.id, this.network).subscribe(
            (res) => {
                if (res.success) {
                    // this.orderDetails = res.data;
                    this.blockUI.stop();
                    this.updateData.emit({ status: 'success', message: `La commande n°${this.orderDetails.id} a bien été expédiée` });
                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.updateData.emit({ status: 'error', message: 'Les paramètres sont invalides' });
                    } else if (res.errorSet.includes('ORDER_NOTFOUND')) {
                        this.updateData.emit({ status: 'error', message: 'La commande n\'existe pas' });
                    } else if (res.errorSet.includes('UNAUTHORIZED')) {
                        this.updateData.emit({ status: 'error', message: 'Vous n\'êtes pas autorisé a annuler cette commande' });
                    } else if (res.errorSet.includes('INVALID_ACTION')) {
                        this.updateData.emit({ status: 'error', message: 'La commande ne peut pas être annulée' });
                    } else {
                        this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.updateData.emit({ status: 'error', message: 'Une erreur s\'est produite' });
            }
        );
    }
}
